module.exports = require('./dist/index')


//////////////////
// WEBPACK FOOTER
// ./~/braintree-dropin-react/index.js
// module id = 766
// module chunks = 0